// // Import Firebase SDKs
// import { initializeApp } from "firebase/app";
// import { getAnalytics, isSupported } from "firebase/analytics";
// import { getAuth, GoogleAuthProvider, OAuthProvider } from "firebase/auth";
// import { getFirestore } from "firebase/firestore";
// import { getStorage } from "firebase/storage";
// import {
//   getMessaging,
//   isSupported as messagingSupported,
//   onMessage,
//   getToken,
// } from "firebase/messaging";

// // Your Firebase configuration
// const firebaseConfig = {
//   apiKey: "AIzaSyC9gq2wC_e3flBu4hfe5bs6kA1ImI3U4Kw",
//   authDomain: "finalroundgame.firebaseapp.com",
//   databaseURL: "https://finalroundgame-default-rtdb.firebaseio.com",
//   projectId: "finalroundgame",
//   storageBucket: "finalroundgame.firebasestorage.app",
//   messagingSenderId: "491596508041",
//   appId: "1:491596508041:web:463129f29dcb2fa0c60f58",
//   measurementId: "G-SSHGDRF0PR",
// };

// // Initialize Firebase
// const app = initializeApp(firebaseConfig);

// // Initialize optional services
// let analytics;
// isSupported().then((yes) => {
//   if (yes) analytics = getAnalytics(app);
// });

// // Export the Firebase services you want to use
// export const auth = getAuth(app);
// export const db = getFirestore(app);
// export const storage = getStorage(app);
// export const googleProvider = new GoogleAuthProvider();
// export const messaging = getMessaging(app);
// export const appleProvider = new OAuthProvider("apple.com");
// export { analytics, onMessage };

// export default app;

// // -------------- Get FCM Token ----------------

// export const requestFcmToken = async () => {
//   try {
//     if (!messaging) {
//       console.warn("Messaging is disabled (HTTP or unsupported browser).");
//       return null;
//     }

//     const token = await getToken(messaging, {
//       vapidKey:
//         "BPs6zVDorlJd2_4zs-U46X6f0FCKpTTfBs6yddt0iJ7IoC1r0Gkp_3cS-uHJLaoggdQnUOOQ0oO4-TDkk8Sdvz4",
//     });

//     if (token) {
//       return token;
//     } else {
//       console.log("No registration token — permission required.");
//     }
//   } catch (error) {
//     console.error("FCM Token Error:", error);
//   }
// };

// Import Firebase SDKs
import { initializeApp } from "firebase/app";
import {
  getAnalytics,
  isSupported as analyticsSupported,
} from "firebase/analytics";
import { getAuth, GoogleAuthProvider, OAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getMessaging, onMessage, getToken } from "firebase/messaging";

// Your Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyC9gq2wC_e3flBu4hfe5bs6kA1ImI3U4Kw",
  authDomain: "finalroundgame.firebaseapp.com",
  databaseURL: "https://finalroundgame-default-rtdb.firebaseio.com",
  projectId: "finalroundgame",
  storageBucket: "finalroundgame.firebasestorage.app",
  messagingSenderId: "491596508041",
  appId: "1:491596508041:web:463129f29dcb2fa0c60f58",
  measurementId: "G-SSHGDRF0PR",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// ---------- Analytics ----------
let analytics = null;
if (typeof window !== "undefined") {
  analyticsSupported().then((yes) => {
    if (yes) analytics = getAnalytics(app);
  });
}

// ---------- Auth / DB / Storage ----------
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const googleProvider = new GoogleAuthProvider();
export const appleProvider = new OAuthProvider("apple.com");

export { analytics, onMessage };
export default app;

// ---------- Messaging (lazy + safe) ----------
let messagingInstance = null;

/**
 * Get messaging instance safely.
 * Does NOT crash on unsupported environments.
 */
export const getMessagingSafe = () => {
  // Already initialized
  if (messagingInstance) return messagingInstance;

  // Not in browser -> e.g. during build / SSR
  if (typeof window === "undefined") {
    console.warn("getMessagingSafe: not in a browser environment.");
    return null;
  }

  // Service workers required for web push
  if (!("serviceWorker" in navigator)) {
    console.warn(
      "getMessagingSafe: service workers not supported in this browser."
    );
    return null;
  }

  try {
    messagingInstance = getMessaging(app);
    return messagingInstance;
  } catch (err) {
    console.error("getMessagingSafe: failed to init messaging:", err);
    return null;
  }
};

// -------------- Get FCM Token ----------------

export const requestFcmToken = async () => {
  try {
    const messaging = getMessagingSafe();

    if (!messaging) {
      console.warn(
        "FCM not available. For web push, you must be on HTTPS (or localhost) with service workers enabled."
      );
      return null;
    }

    const token = await getToken(messaging, {
      vapidKey:
        "BPs6zVDorlJd2_4zs-U46X6f0FCKpTTfBs6yddt0iJ7IoC1r0Gkp_3cS-uHJLaoggdQnUOOQ0oO4-TDkk8Sdvz4",
    });

    if (token) {
      console.log("FCM token:", token);
      return token;
    } else {
      console.log(
        "No registration token — permission might be blocked or not granted."
      );
      return null;
    }
  } catch (error) {
    console.error("FCM Token Error:", error);
    return null;
  }
};
